import React from 'react';
import { ItemImageStyle, ItemStyle } from './styles';
import { BodyTextRegularD } from '@/shared/ui/typography2';

export const MobileButton = React.forwardRef<HTMLDivElement, MobileButtonProps>(
  (
    {
      title,
      src,
      srcActive,
      $isActive,
      handlerClick: handler,
      disabled,
      $decored = false,
    },
    ref
  ) => {
    return (
      <ItemStyle
        id={title}
        onClick={handler}
        ref={ref}
        $isActive={$isActive}
        $decored={$decored}
        isDisabled={disabled}
      >
        <ItemImageStyle>
          <img src={$isActive ? srcActive : src} alt={title} />
        </ItemImageStyle>
        <BodyTextRegularD>{title}</BodyTextRegularD>
      </ItemStyle>
    );
  }
);

MobileButton.displayName = 'MobileButton';

type MobileButtonProps = {
  title: string;
  src: string;
  handlerClick: () => void;
  $isActive?: boolean;
  $decored?: boolean;
  isDisabled?: boolean;
};
